export const isTrueObject = (v: unknown): v is Record<string, unknown> =>
  v !== null && !Array.isArray(v) && typeof v === 'object';
